import React from "react";
import {useHistory} from "react-router";

import {SSO_LOGIN_FEATURE_FLAG} from "ubcommunity-shared/src/featureFlags";
import LoginForm from "ubcommunity-shared/src/Auth/LoginForm/LoginForm";
import {PageTitles} from "ubcommunity-shared/src/constants";
import {usePageTitle} from "ubcommunity-shared/src/Hooks/usePageTitle";
import {useIsFeatureEnabledBoolean} from "ubcommunity-shared/src/Hooks/useIsFeatureEnabledBoolean";

import AuthPage from "../AuthPage/AuthPage";
import {BackButton} from "../../Layout/BackButton/BackButton";
import LoginFlow from "./LoginFlow";

export default function Login() {
    usePageTitle(PageTitles.LOGIN);
    const history = useHistory();

    const isSSOAuthEnabled = useIsFeatureEnabledBoolean(SSO_LOGIN_FEATURE_FLAG);

    return (
        <AuthPage title="" headerLeftButton={<BackButton to="" onClick={() => history.goBack()} />}>
            {isSSOAuthEnabled ? <LoginFlow /> : <LoginForm />}
        </AuthPage>
    );
}
